import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import Title from '../../../../../@casino/ui/title';
import {setGetProviderList} from '../../store/thunk/setGetProviderList';
import {setGetUpdateGame} from '../../store/thunk/setGetUpdateGame';
import {getRows, columns} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
        display: 'flex',
        justifyContent: 'space-between'
    },
    refreshGame: {
        padding: 10, 
        background: '#ffc324', 
        borderRadius: 4, 
        cursor: 'pointer', 
        color: '#141b33'
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}))


const ReportProvider = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [openModal, setOpenModal] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetProviderList({
            date_from: 0,
            date_to: new Date().getTime()
        }));
    }, [])
    
    const provider = useSelector(state => state.provider.list)
    const rows = React.useMemo(() => getRows(provider), [provider])

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});

    return (
        <div className={classes.root}>
            <Title label="Отчет по провайдерам" />
            
            <div className={classes.wrapBlock}>
                <FormikContext.Provider value={formik}>
                    <form>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                    onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }
                                    formik.setFieldValue('date_from', date.getTime());
                                    dispatch(setGetProviderList({
                                        search: formik.values.search,
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                        page: 1,
                                        rowsPerPage: 25,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }
                                    formik.setFieldValue('date_to', date.getTime());
                                    dispatch(setGetProviderList({
                                        search: formik.values.search,
                                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                        date_to: isNaN(date.getTime()) ? new Date().getTime() : date.getTime(),
                                        page: 1,
                                        rowsPerPage: 25,
                                    }))        
                                }}
                            />
                        </div>
                    </form>
                </FormikContext.Provider>
                <span className={classes.refreshGame} onClick={() => setOpenModal(true)}>Обновить игры</span>
            </div>
            <div className={classes.wrapTable}>
                <TableCasino
                    width={1000}
                    columns={columns}
                    rows={rows} 
                />
            </div>
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div style={{padding: 20}}>
                    <h3 style={{color: '#2f2f2f', padding: 0, margin: 0}}>Вы точно хотите обновить игры?</h3>
                    <div style={{display: 'flex', justifyContent: 'space-between', gap: 5, marginTop: 12}}>
                        <span 
                            onClick={() => {
                                dispatch(setGetUpdateGame());
                                setOpenModal(false)
                            }}
                            style={{width: '50%', background: '#ffc324', borderRadius: 4, padding: 8,textAlign: 'center', color: '#141b33', cursor: 'pointer'}}
                        >Обновить</span>
                        <span 
                            onClick={() => {
                                setOpenModal(false)
                            }}
                            style={{width: '50%', border: '1px solid #141b33', borderRadius: 4, padding: 8,textAlign: 'center', cursor: 'pointer'}}
                        >Отмена</span>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default ReportProvider